
const state = {
  activeTab:'',
  user:{
  }
}
const mutations = {
  saveActiveTab(state,pathName){
    state.activeTab = pathName;
  },
  gertUsers(state,user){
    state.user = user;
  },
}
export default{
    state,
    mutations,
}